'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { Button } from '@/app/components/button';
import { IconArrowBack } from '@/app/components/icons/ui-actions/icon-arrow-back';
import { IconClose } from '@/app/components/icons/ui-actions/icon-close';
import { BaseDealerModal } from '@/app/components/sections/dealer/components/shared/base-dealer-modal';
import { SearchBox } from '@/app/components/sections/dealer/components/shared/smart-search/search-box';
import { trackDealer } from '@/app/components/sections/dealer/utils/tracking';
import { type BaseSearchBoxProps } from '@/app/components/sections/dealer/utils/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const DealerSearchOverlay = t0 => {
  const $ = _c(27);
  const {
    isOpen,
    onClose,
    searchBoxProps
  } = t0;
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (!isOpen) {
        return;
      }
      trackDealer({
        group: "components/shared/dealer/shared/smart-search/search-overlay"
      });
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconArrowBack />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "back-button"
    });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClose || $[6] !== t4) {
    t5 = <Button className="xl:hidden" variant="tertiary" color="black" aria-label="Back" iconBefore={t3} onClick={onClose} {...t4} />;
    $[5] = onClose;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-sub-h3 font-noto-bold xl:text-sub-h1" {...createDataAttributes({
      test: "title"
    })}>ค้นหาโชว์รูม / ศูนย์บริการ</span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconClose />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = createDataAttributes({
      test: "modal-close-button"
    });
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onClose || $[12] !== t8) {
    t9 = <Button className="pointer-events-none invisible xl:pointer-events-auto xl:visible" variant="tertiary" aria-label="Close" color="black" iconBefore={t7} onClick={onClose} {...t8} />;
    $[11] = onClose;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t9) {
    t10 = <div className="relative flex items-center justify-between px-4 pt-3 pb-2 xl:px-10 xl:pt-10 xl:pb-6">{t5}{t6}{t9}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = searchBoxProps?.value ?? "";
  let t12;
  if ($[18] !== onClose || $[19] !== searchBoxProps || $[20] !== t11) {
    t12 = <SearchBox searchWrapperClassName="px-4 pb-3 xl:px-10 xl:pb-0" {...searchBoxProps} onClose={onClose} value={t11} />;
    $[18] = onClose;
    $[19] = searchBoxProps;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== isOpen || $[23] !== onClose || $[24] !== t10 || $[25] !== t12) {
    t13 = <BaseDealerModal isOpen={isOpen} onClose={onClose}>{t10}{t12}</BaseDealerModal>;
    $[22] = isOpen;
    $[23] = onClose;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};